import { FirstRenderContext } from "@montana/context/first-render.context";
import { IPageContainerProps } from "@montana/containers/page";
import { staticSettings } from "@montana/helpers/static-settings.helper";
import { hideZendeskChat, showZendeskChat } from "@montana/helpers/zendesk-chat.helper";
import { useContext, useEffect } from "react";
import { useSettings } from '@montana/containers/settings/settings.container';

export function useZendeskChat({ hideZendesk }: IPageContainerProps) {
    const { isDebugging } = staticSettings;
    const isFirstRender = useContext(FirstRenderContext);
    const { market } = useSettings();

    useEffect(() => {
        const showChat = !hideZendesk && !isFirstRender && market?.enableZendesk;
        if (showChat) {
            showZendeskChat(!isDebugging);
        } else {
            hideZendeskChat();
        }
    }, [hideZendesk, isFirstRender, market?.enableZendesk]);
}
